import { MIME_TYPES } from '@vy/files';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type GetInvoiceUsageEventsReportRequest = { invoiceId: string };
type GetInvoiceUsageEventsReportResponse = { blob: Blob; isZip: boolean };

export function useGetInvoiceUsageEventsReport(
  options?: UseMutationOptions<GetInvoiceUsageEventsReportResponse, unknown, GetInvoiceUsageEventsReportRequest>,
) {
  return useMutation({
    mutationFn: async ({ invoiceId }) => {
      const api = getPrivateApi();
      const rawResponse = await api.getInvoiceUsageEventsReportRaw({ invoiceId });
      const contentType = rawResponse.raw.headers.get('content-type') ?? '';
      const isZip = contentType === MIME_TYPES.ZIP;
      const blob = await rawResponse.raw.blob();

      return { blob, isZip };
    },
    ...options,
  });
}
